// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__4Kpp2","Logo":"Toolbar_Logo__38s1h","DesktopOnly":"Toolbar_DesktopOnly__37nA8"};